import { graphql, useFragment as unmask, type FragmentType } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { BUY_LISTS_QUERY_KEY } from '~/api/buyList';
import { useOrganizationsContactData } from '~/api/organizationContactData';
import type { ContactDetails, ContactsStatus } from '~/utils/contact';

export const primaryContactFragment = graphql(`
  fragment PrimaryContact on User {
    id
    firstName
    lastName
  }
`);

export type PrimaryContactRef = FragmentType<typeof primaryContactFragment>;

export function unmaskPrimaryContact(
  ref: PrimaryContactRef | null | undefined
) {
  return unmask(primaryContactFragment, ref);
}

const chooseQuoteContactsMutation = graphql(`
  mutation ChooseQuoteContacts(
    $quoteId: ID!
    $primaryContactUserId: ID!
    $recipientUserIds: [ID!]!
  ) {
    chooseQuoteContacts(
      quoteId: $quoteId
      primaryContactUserId: $primaryContactUserId
      recipientUserIds: $recipientUserIds
    ) {
      id
    }
  }
`);

export const useChooseQuoteContacts = () =>
  useGraphqlMutation(
    chooseQuoteContactsMutation,
    ['requestForQuote', BUY_LISTS_QUERY_KEY],
    undefined,
    { invalidateOnError: true }
  );

export function useSellerContacts(organizationId: string): {
  contacts: ContactDetails[];
  status: ContactsStatus;
} {
  const { data, isLoading, error } = useOrganizationsContactData([
    organizationId,
  ]);
  const contacts: ContactDetails[] =
    data?.organizationsByIds[0]?.sellerContacts ?? [];
  if (isLoading) {
    return { contacts, status: 'loading' };
  }
  if (error && !data) {
    return { contacts, status: 'failed' };
  }
  return { contacts, status: 'loaded' };
}
